import { Location, Editor } from 'domains/reporter/RichTextEditor/core';
import { Transforms } from 'slate';
import { ReactEditor } from 'slate-react';

// When focus is called in certain contexts, it does focus the editor but another action de-focuses it.
// For example, clicking a button in a modal the editor will not actually be focused in the end
// Use requestAnimationFrame to ensure the editor ends up focused after the current frame
export const focusEditor = (editor: null | Editor) => {
  if (editor != null) {
    requestAnimationFrame(() => {
      ReactEditor.focus(editor);
    });
  }
};

// Same as focusEditor but also selects a path if you need to change the
// selection. If you try to do the select outside of requestAnimationFrame, you will end
// up with an odd editor state where it is focused, and visually the selection
// is in the correct place, but the first character you type will be in the old
// selection location.
export const selectAndFocusEditor = (editor: null | Editor, path: Location) => {
  if (editor != null) {
    requestAnimationFrame(() => {
      ReactEditor.focus(editor);
      Transforms.select(editor, path);
    });
  }
};
